import React, {Component} from "react";

import {BannerHeader} from "../structure";
import {Footer} from './../common/common';

import bgImg from "../../resources/images/bg-register.jpg"

class Cookies extends Component{
	componentDidMount() {
		document.getElementById("content").scrollTo(0, 0);
	}
	render(){
		return(
			<article className="festenInfoPage">
				<BannerHeader bgImage={bgImg}>
					<h1>Cookies</h1>
				</BannerHeader>
				
				<div className="maxWidth">

					<section className="infoSection">
						<h1>Introduktion</h1>
						<p>
							N&aring;r du bes&oslash;ger vores website indsamles der oplysninger om dig, som bruges til at tilpasse og
							forbedre vores indhold og til at &oslash;ge v&aelig;rdien af de annoncer, der vises p&aring; siden.
						</p>
						<p>
							Hvis du ikke &oslash;nsker, at der indsamles oplysninger, b&oslash;r du slette dine cookies 
							(<a href="https://minecookies.org/cookiehandtering">se vejledning</a>)
							og undlade videre brug af websitet.
						</p> 
						<p>
							Nedenfor har vi uddybet, hvilke informationer der indsamles, 
							deres form&aring;l og hvilke tredjeparter, der har adgang til dem.
						</p>
					</section>

					<section className="infoSection">
						<h1>Udgiver</h1>
						<p>
							Websitet ejes og publiceres af:<br/><br/> 
							Festen.dk ApS<br/> 
							CVR: 34725195<br/> 
							Sdr. Boulevard 42, kld. tv.<br/> 
							5000 Odense C<br/> 
							Telefon: 78 70 78 88<br/> 
							Email: <a href="mailto:kundeservice@festen.dk">kundeservice@festen.dk</a>
						</p>
					</section>

					<section className="infoSection">
						<h1>Cookies</h1>
						<p>
							Websitet anvender &rdquo;cookies&rdquo;, der er en tekstfil, som gemmes p&aring; din computer, mobil el.
							tilsvarende med det form&aring;l at genkende den, huske indstillinger, udf&oslash;re statistik og
							m&aring;lrette annoncer. Cookies kan ikke indeholde skadelig kode som f.eks. virus.
						</p>
						<p>
							Hvis du sletter eller blokerer cookies vil annoncer kunne blive mindre relevante for dig og optr&aelig;de
							hyppigere. Du kan desuden risikere at websitet ikke fungerer optimalt samt at der er indhold, du ikke kan
							f&aring; adgang til.
						</p>
						<p>
							Websitet indeholder cookies fra tredjeparter, der i varierende omfang kan omfatte:
						</p>

						<table>
							<thead>
								<tr>
									<th>Cookie Name</th>
									<th>Cookie Description</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>CookiesAccepted</td>
									<td>En cookie der indikerer at brugeren har accepteret cookies.</td>
								</tr>
								<tr>
									<td>session</td>
									<td>En cookie der identificerer din session. Dette er hvad der tillader dig at komme tilbage hvis du lukker din browser.</td>
								</tr>
								<tr>
									<td>userToken</td>
									<td>Denne cookie er bundet til den bruger du er logget ind som, og tillader dig at tilgå dine personlige fester.</td>
								</tr>
							</tbody>
						</table>
					</section>

					<section className="infoSection">
						<h1>Personoplysninger</h1>
						<h2>Generelt</h2>
						<p>
							Personoplysninger er alle slags informationer, der i et eller andet omfang kan henf&oslash;res til dig.
							N&aring;r du benytter vores website indsamler og behandler vi en r&aelig;kke s&aring;danne informationer.
							Det sker f.eks. ved alm. tilgang af indhold, hvis du tilmelder dig vores nyhedsbrev, deltager i konkurrencer
							eller unders&oslash;gelser, registrerer dig som bruger eller abonnent, &oslash;vrig brug af services eller
							foretager k&oslash;b via websitet.
						</p>

						<h2>Sikkerhed</h2>
						<p>
							Vi har truffet tekniske og organisatoriske foranstaltninger mod, at dine oplysninger h&aelig;ndeligt eller
							ulovligt bliver slettet, offentliggjort, fortabt, forringet eller kommer til uvedkommendes kendskab,
							misbruges eller i &oslash;vrigt behandles i strid med lovgivningen.
						</p>

						<h2>Form&aring;l</h2>
						<p>
							Oplysningerne bruges til at identificere dig som bruger og vise dig de annoncer, som vil have st&oslash;rst
							sandsynlighed for at v&aelig;re relevante for dig, at registrere dine k&oslash;b og betalinger, samt at
							kunne levere de services, du har efterspurgt, som f.eks. at fremsende et nyhedsbrev. Herudover anvender vi
							oplysningerne til at optimere vores services og indhold.
						</p>

						<h2>Periode for opbevaring</h2>
						<p>
							Oplysningerne opbevares i det tidsrum, der er tilladt i henhold til lovgivningen, og vi sletter dem,
							n&aring;r de ikke l&aelig;ngere er n&oslash;dvendige. Perioden afh&aelig;nger af karakteren af oplysningen
							og baggrunden for opbevaring. Det er derfor ikke muligt at angive en generel tidsramme for, hvorn&aring;r
							informationer slettes.
						</p>
					</section>

					<section className="infoSection">
						<h2>Videregivelse af oplysninger</h2>
						<p>
							Data om din brug af websitet, hvilke annoncer, du modtager og evt. klikker p&aring;, geografisk placering,
							k&oslash;n og alderssegment m.v. videregives til tredjeparter i det omfang disse oplysninger er kendt. Du
							kan se hvilke tredjeparter, der er tale om, i afsnittet om &rdquo;Cookies&rdquo; ovenfor. Oplysningerne
							anvendes til m&aring;lretning af annoncering.
						</p>
						<p>
							Vi benytter herudover en r&aelig;kke tredjeparter til opbevaring og behandling af data. Disse behandler
							udelukkende oplysninger p&aring; vores vegne og m&aring; ikke anvende dem til egne form&aring;l.
						</p>
						<p>
							Videregivelse af personoplysninger som navn og e-mail m.v. vil kun ske, hvis du giver samtykke til det. Vi
							anvender kun databehandlere i EU eller i lande, der kan give dine oplysninger en tilstr&aelig;kkelig
							beskyttelse.
						</p>

						<h2>Indsigt og klager</h2>
						<p>
							Du har ret til at f&aring; oplyst, hvilke personoplysninger, vi behandler om dig. Du kan desuden til enhver
							tid g&oslash;re indsigelse mod, at oplysninger anvendes. Du kan ogs&aring; tilbagekalde dit samtykke til, at
							der bliver behandlet oplysninger om dig. Hvis de oplysninger, der behandles om dig, er forkerte har du ret
							til at de bliver rettet eller slettet. Henvendelse herom kan ske til: <a href="mailto:kundeservice@festen.dk">kundeservice@festen.dk</a>. Hvis du
							vil klage over vores behandling af dine personoplysninger, har du ogs&aring; mulighed for at tage kontakt
							til <a href="https://www.datatilsynet.dk/">Datatilsynet</a>.
						</p>
					</section>
				</div>
				<Footer/>
			</article>
		)
	}	
};

export default Cookies;



// WEBPACK FOOTER //
// ./src/components/infoPages/cookies.js